module.exports = __webpack_public_path__ + "static/media/Dec503.catalyst.dec7b9cc.tsx";